export const REQUIRE_EMAIL_MODAL_ID = 'requireEmailModal'

export const getRequireEmailModalDismissedQueryKey = (userId: string) =>
    ['require_email_modal', 'dismissed', userId] as const
